import { viewportSchema } from '../schemas'
import { renderSchemaArray } from '../utils'
import { withParsedData } from './base'

export const ViewportRenderer = withParsedData(viewportSchema)(({ parsedData }) => {
  const { body } = parsedData
  const children = renderSchemaArray(body)
  return <div>{children}</div>
})
